// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"c260ff44","257":"c4f61356","425":"a6282439","453":"1aecd90a","666":"43200d75","719":"54fa6443","903":"58519f11"}[chunkId] + ".chunk.js";
};